
type IconProps = {
  name: String;
};

export default function Icon(props: IconProps) {
  return <i className={`icon icon-${props.name}`}></i>;
}
